import {defineType} from 'sanity'
import {ComponentPreview} from './ComponentPreview'
import {FaFileDownload} from 'react-icons/fa'

export default defineType({
  type: 'object',
  name: 'download-file',
  title: 'Download File',
  icon: FaFileDownload,
  components: {
    preview: (props) => <ComponentPreview {...props} />,
  },
  fields: [
    {
      name: 'file',
      type: 'file',
      title: 'File',
    },
    {
      name: 'title',
      type: 'string',
      title: 'Title',
    },
    {
      name: 'content',
      type: 'text',
      title: 'Content',
    },
    {
      name: 'buttonLabel',
      type: 'string',
      title: 'Download Button Label',
    },
  ],
  preview: {
    select: {
      title: 'title',
      subtitle: 'content',
      media: 'file',
    },
  },
  //   components: {
  //     block: InlineBannerBlock,
  //   },
})
